import { Popconfirm } from 'antd'
import { WithRecord } from '../../../../../../types'
import { useCIMSTableContext } from '../../../../..'
import { useState } from 'react'
import { RowActionButtonFn } from '../types'
import DisablableRowActionButton from './DisablableRowActionButton'

function RemoveRowActionButton<T extends object>({ record }: WithRecord<T>) {
  const { rowKey, actions } = useCIMSTableContext<T>()
  const [visible, setVisible] = useState<string | undefined>()
  const remove = actions.row?.remove
  const { onRemove, disabled } = remove ?? {}
  const resolvedKey =
    typeof rowKey === 'function' ? rowKey(record) : String(record[rowKey])
  const key = `remove-${resolvedKey}`
  const suffix = remove?.hard ? ' This record type cannot be recovered!' : ''
  const skip =
    remove?.hard === true
      ? false
      : typeof remove?.skipConfirm === 'function'
      ? remove?.skipConfirm(record)
      : remove?.skipConfirm

  const Remove: React.VFC<{ callback?: RowActionButtonFn<T, any> }> = (
    props
  ) => {
    return (
      <DisablableRowActionButton {...props} record={record} disabled={disabled}>
        Remove
      </DisablableRowActionButton>
    )
  }

  if (remove?.hard === false && skip)
    return <Remove key={key} callback={onRemove} />

  return (
    <Popconfirm
      key={key}
      title={`Are you sure you want to remove this record?${suffix}`}
      onCancel={() => setVisible(undefined)}
      onConfirm={async () => {
        setVisible(undefined)
        await onRemove?.(record)
      }}
      placement="topRight"
      visible={visible === key}
    >
      <Remove callback={() => setVisible(key)} />
    </Popconfirm>
  )
}

export default RemoveRowActionButton
